export const useTokenGlobalPositionToSentenceTokens = (
  documentId: string,
  tokenGlobalPosition: number
) => {
  const tokenId =
    useDocumentTokenIdPositionMapStore(documentId).tokenIdFromGlobalPosition(
      tokenGlobalPosition
    );

  if (tokenId == undefined) return [tokenGlobalPosition];

  const sentence =
    useDocumentEvaluativeParagraphsStore(documentId).sentenceFromTokenId(
      tokenId
    );

  if (sentence == undefined) return [tokenGlobalPosition];

  const sentenceTokenPositions = sentence.tokens.map((t) =>
    useDocumentTokenIdPositionMapStore(documentId).tokenGlobalPositionFromId(
      t.id
    )
  );

  return sentenceTokenPositions;
};
